import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { getList } from "../../services/lists";
import { SingleListResponse } from "../../types/lists.types";

export const useListQuery = (listName: string) => {
  const { i18n } = useTranslation();
  return useQuery<SingleListResponse>({
    queryKey: ["lists", listName, i18n.language],
    queryFn: () => getList(listName),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!listName,
  });
};
